import { SadmProtocol } from '@pixacare/dtos';

// The backend does not guarantee any ordering on an entity's protocols history, so the protocol
// in effect is the most recently created one, not the first of the array.
export const getLatestProtocol = (protocolsHistory: SadmProtocol[]): SadmProtocol => {
  if (!protocolsHistory?.length) {
    return null;
  }

  return protocolsHistory.reduce((latest, protocol) =>
    protocol.createdOn.getTime() > latest.createdOn.getTime() ? protocol : latest,
  );
};
